package com.arenaproplay.admin.ui.utils

/** JS built-in — available in every browser environment. */
private external fun encodeURIComponent(str: String): String

/**
 * Percent-encodes a query-parameter value so that characters like
 * `&`, `+`, `#`, `=`, and spaces cannot corrupt the forwarded URL.
 *
 * Usage: `"?foo=${encodeQueryValue(value)}"`
 */
fun encodeQueryValue(v: String): String = encodeURIComponent(v)
